import React, { useContext } from "react";
import "./Intro.css";
import Typed from "react-typed";
import Vector1 from "../../img/Vector1.png";
import Vector2 from "../../img/Vector2.png";
import vivek from "../../img/vivek.png";
import glassesimoji from "../../img/glassesimoji.png";
import thumbup from "../../img/thumbup.png";
import crown from "../../img/crown.png";
import FloatinDiv from "../FloatingDiv/FloatingDiv";
import Github from "../../img/github.png";
import LinkedIn from "../../img/linkedin.png";
import Instagram from "../../img/instagram.png";
import Twitter from "../../img/twitter9.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
const Intro = () => {
  // Transition
  const transition = { duration: 2, type: "spring" };

  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="Intro" id="Intro">
      {/* left name side */}
      <div className="i-left">
        <div className="i-name">
          {/* yahan change hy darkmode ka */}
          <span style={{ color: darkMode ? "white" : "" }}>Hy! I Am</span>
          <span>Vivek Kumar</span>

          <Typed
              strings={[
                
            "... I'm Developer.",
            "... I write code.",
            "... I'm Software Developer.",
            "... I make software.",
            "... I'm Software Engineer.",
            "... I solve software engineering problem.",
            "... I'm Software Programmer.",
            "... I make programming logic.",
          ]}
          typeSpeed={25}
          backSpeed={25}
          loop
        />
        </div>
        <Link to="contact" smooth={true} spy={true}>
          <button className="button i-button">Hire me</button>
        </Link>
        {/* social icons */}
        <div className="i-icons">
        
          <a href="https://github.com/vivek2502">
            <img src={Github} alt="" />
          </a>
          <a href="https://www.linkedin.com/in/vivek-kumar-a7102316b">
          <img src={LinkedIn} alt="" />
          </a>
          <a href="https://twitter.com/VIVEKKU50957304">
          <img src={Twitter} alt="" />
          </a>
          <a href="https://www.instagram.com/captain_vivek/">
          <img src={Instagram} alt="" />
          </a>
            
        </div>
      </div>
      {/* right image side */}
      <div className="i-right">
        <img src={Vector1} alt="" />
        <img src={Vector2} alt="" />
        <img src={vivek} alt="" />
        {/* animation */}
        <motion.img
          initial={{ left: "-36%" }}
          whileInView={{ left: "-24%" }}
          transition={transition}
          src={glassesimoji}
          alt=""
        />

        <motion.div
          initial={{ top: "-4%", left: "74%" }}
          whileInView={{ left: "68%" }}
          transition={transition}
          className="floating-div"
        >
          <FloatinDiv img={crown} text1="Software" text2="Developer" />
        </motion.div>

        {/* animation */}
        <motion.div
          initial={{ left: "9rem", top: "18rem" }}
          whileInView={{ left: "0rem" }}
          transition={transition}
          className="floating-div"
        >
          {/* floatinDiv mein change hy dark mode ka */}
          <FloatinDiv img={thumbup} text1="Block-chain" text2="Developer" />
        </motion.div>

        <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
        <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-9rem",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Intro;
